module.exports = __webpack_public_path__ + "static/media/cr4.a792ed1f.png";